module.exports = __webpack_public_path__ + "img/logo.4be00eb7.png";